import { render, staticRenderFns } from "./PT310OtherParts.vue?vue&type=template&id=42f8d566&"
import script from "./PT310OtherParts.vue?vue&type=script&lang=js&"
export * from "./PT310OtherParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports